import { createModule, mutation } from 'vuex-class-component';

const vuexModule = createModule({
  namespaced: 'aconex',
  strict: false,
});

// CONSIDER if we need to store the callback somethingsomething here. I don't think so?

export default class AconexModule extends vuexModule {
  private _IsBusy = false;
  private _Message = '';

  // * GETTERS
  public get isBusy() {
    return this._IsBusy;
  }

  public get message() {
    return this._Message;
  }

  // * MUTATIONS
  @mutation public setIsBusy(show: boolean) {
    this._IsBusy = show;
  }

  @mutation public setMessage(message: string) {
    this._Message = message;
  }
}
